// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2iSvh","placeholdersHeader":"styles_placeholdersHeader__2KLOD","editorStyle":"styles_editorStyle__4N8eZ","placeholdersBox":"styles_placeholdersBox__3ZYLN"};